import React, { useState, useEffect } from "react";
import Axios from "axios";
import { API_BASE_URL } from "../../Config";
import PropTypes from "prop-types";
import SpinLoader from "../loader/SpinLoader";

const ViewAdvanceBooking = ({ booking }) => {
  const quotationId = booking?.Id;
  const [userDataSession, setUserDataSession] = useState(null);
  const [data, setData] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formattedDate, setFormattedDate] = useState("");
  const [formattedExpectedDate, setFormattedExpectedDate] = useState("");

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    }
  }, []);

  useEffect(() => {
    if (data) {
      if (data?.Quotaiondate) {
        const date = new Date(data?.Quotaiondate);
        setFormattedDate(date.toISOString().split("T")[0]);
      }
      if (data?.ExpectedDelivery) {
        const expDate = new Date(data.ExpectedDelivery);
        setFormattedExpectedDate(expDate.toISOString().split("T")[0]);
      }
    }
  }, [data]);

  useEffect(() => {
    if (!quotationId || !userDataSession?.OrgId) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const url = `${API_BASE_URL}Billing/getQuotationsById?QuotaionId=${quotationId}`;
        const res = await Axios.get(url);
        if (res.data.Status && res.data.ResultData?.length) {
          const result = res.data.ResultData;
          setData(result[0]);
          setProducts(result);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [quotationId, userDataSession]);

  return (
    <>
      {loading && <SpinLoader />}
      <div
        className="offcanvas offcanvas-end "
        id="offcanvasViewAdvanceBooking"
        tabIndex="-1"
        style={{ maxWidth: "40%" }}
      >
        <div className="offcanvas-header">
          <h4>View Advance Booking ({data?.QuotaionNo})</h4>
          <button className="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>
        <hr />

        <div className="offcanvas-body">
          {/* Customer Info */}
          <div className="row g-3 mb-3">
            <div className="col-6">
              <label className="form-label ">Customer Name</label>
              <input
                type="text"
                className="form-control "
                value={data?.CustomerName || "Walk-in"}
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label ">Mobile No</label>
              <input
                type="text"
                className="form-control "
                value={data?.CustomerMobile || "—"}
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label ">Date</label>
              <input
                type="text"
                className="form-control "
                value={formattedDate}
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label ">Expected Delivery</label>
              <input
                type="text"
                className="form-control "
                value={formattedExpectedDate}
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label ">Advance Paid</label>
              <input
                type="text"
                className="form-control "
                value={`₹${parseFloat(data?.AdvanceAmount || 0).toFixed(2)}`}
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label">Total Amount</label>
              <input
                type="text"
                className="form-control "
                value={`₹${parseFloat(data?.HeaderTotal || 0).toFixed(2)}`}
                readOnly
              />
            </div>
          </div>

          {/* Products Table */}
          <div className="table-responsive" style={{ maxHeight: "200px" }}>
            <table className="table table-sm ">
              <thead>
                <tr>
                  <th>Product</th>
                  <th className="text-center">Qty</th>
                  <th className="text-end">Price</th>
                </tr>
              </thead>
              <tbody>
                {products.map((item, i) => (
                  <tr key={i}>
                    <td className="small">{item.ProductName}</td>
                    <td className="text-center small">{item.Quantity}</td>
                    <td className="text-end small">
                      ₹{item.UnitPrice.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <hr />

          {/* Compact Totals */}
          <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded small mb-1 d-none">
            <span>Sub Total:</span>
            <strong>₹{parseFloat(data?.HeaderTotal || 0).toFixed(2)}</strong>
          </div>
          <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded small mb-1 d-none">
            <span>Advance Paid:</span>
            <strong className="text-success">
              - ₹{parseFloat(data?.AdvanceAmount || 0).toFixed(2)}
            </strong>
          </div>
          <div className="d-flex justify-content-between align-items-center bg-primary text-white p-2 rounded small d-none">
            <span className="fw-bold">Balance Due:</span>
            <strong>
              ₹
              {(
                parseFloat(data?.HeaderTotal || 0) -
                parseFloat(data?.AdvanceAmount || 0)
              ).toFixed(2)}
            </strong>
          </div>

          <div className="modal-footer-btn mt-3">
            <button
              className="btn btn-cancel btn-sm"
              data-bs-dismiss="offcanvas"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

ViewAdvanceBooking.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default ViewAdvanceBooking;
